export default {
  DOMAIN_URL: 'https://tln773viuf.execute-api.ap-northeast-1.amazonaws.com/prod'
}
